import { Table, Tbody, Td, Th, Thead, Tr, VStack } from "@chakra-ui/react"
import React, { Fragment } from "react"

export type UserLocationRecordsReportProps = {
	report: any
}

export const UserLocationRecordsReport: React.FC<UserLocationRecordsReportProps> = ({ report }) => {
	return (
		<VStack w="full" align="stretch" h="full" overflow="auto" spacing={0}>
			<Table size="sm">
				<Thead>
					<Tr>
						<Th>Date</Th>
						<Th>User</Th>
						<Th>Zone</Th>
						<Th>Start</Th>
						<Th>End</Th>
						<Th>Status</Th>
						<Th>Duration</Th>
						<Th>Restricted</Th>
					</Tr>
				</Thead>
				<Tbody>
					{Object.keys(report).map((key, index) => (
						<Fragment key={key}>
							{report?.[key].map((o: any, i: number) => (
								<Tr key={i} bgColor={index % 2 === 0 ? "transparent" : "gray.100"}>
									<Td>{o.date}</Td>
									<Td>{o.user}</Td>
									<Td>{o.zone}</Td>
									<Td>{o.start}</Td>
									<Td>{o.end}</Td>
									<Td>{o.status}</Td>
									<Td>{o.duration}</Td>
									<Td>{o.restricted || "-"}</Td>
								</Tr>
							))}
						</Fragment>
					))}
				</Tbody>
			</Table>
		</VStack>
	)
}
